import { Box, Card, TopList } from '@factorialco/deprecated-design-system'

import BlankSlate from 'modules/insights/components/BlankSlate'
import ChartTooltip from 'modules/insights/components/ChartTooltip'
import TooltipLegend from 'modules/insights/components/TooltipLegend'

interface DataItem {
  label: string
  value: number
}

interface Props {
  data: DataItem[]
  title: string
  subtitle: string
  valueTitle: string
  info: string
  formatValue?: (value: number) => string
}

export const DataList = ({ data, title, subtitle, valueTitle, info, formatValue }: Props) => {
  type DisplayData = Array<{ label: string; value: number | string }>

  const displayData: DisplayData = formatValue
    ? data.map((item) => ({
        label: item.label,
        value: formatValue(item.value),
      }))
    : data

  return (
    <Card>
      <Card.Title tooltip={info}>{title}</Card.Title>
      <Card.Content>
        {data.length == 0 && <BlankSlate />}
        {data.length > 0 && (
          <Box maxHeight="s600" width="full" overflowY="auto" flexDirection="column">
            <TopList
              leftColumnHeader={subtitle}
              rightColumnHeader={valueTitle}
              // @ts-expect-error TopList accepts string values at runtime for display
              data={displayData}
              tooltip={({ label, value }) => (
                <ChartTooltip title={label}>
                  <TooltipLegend color="viridian1000" name={valueTitle} value={value} />
                </ChartTooltip>
              )}
            />
          </Box>
        )}
      </Card.Content>
    </Card>
  )
}
